// Dans src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'

// Imports des pages françaises
import HomeView from '../views/HomeView.vue'
import SaasServicesPage from '../views/SaasServicesPage.vue'
import ChatbotServicePage from '../views/ChatbotServicePage.vue' 
import NoCodeServicePage from '../views/NoCodeServicePage.vue'
import SeoServicePage from '../views/SeoServicePage.vue'
import DataSciencePage from '../views/DataSciencePage.vue'
import ContactView from '../views/ContactView.vue'
import MentionsLegalesPage from '../views/MentionsLegalesPage.vue'

// Imports des pages anglaises
import HomeViewEn from '../views/en/HomeView.vue'
// Vous devrez créer ces composants pour les pages anglaises
import SaasServicesPageEn from '../views/en/SaasServicesPage.vue'
import ChatbotServicePageEn from '../views/en/ChatbotServicePage.vue'
import NoCodeServicePageEn from '../views/en/NoCodeServicePage.vue'
import SeoServicePageEn from '../views/en/SeoServicePage.vue'
import DataSciencePageEn from '../views/en/DataSciencePage.vue'
import ContactViewEn from '../views/en/ContactView.vue'
import MentionsLegalesPageEn from '../views/en/MentionsLegalesPage.vue'

// Routes françaises (par défaut)
const frenchRoutes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { locale: 'fr' }
  },
  {
    path: '/saas',
    name: 'saas',
    component: SaasServicesPage,
    meta: { locale: 'fr' }
  },
  {
    path: '/chatbot',
    name: 'chatbot',
    component: ChatbotServicePage,
    meta: { locale: 'fr' }
  },
  {
    path: '/nocode',
    name: 'nocode',
    component: NoCodeServicePage,
    meta: { locale: 'fr' }
  },
  {
    path: '/seo',
    name: 'seo',
    component: SeoServicePage,
    meta: { locale: 'fr' }
  },
  {
    path: '/contact',
    name: 'contact',
    component: ContactView,
    meta: { locale: 'fr' }
  },
  {
    path: '/datascience',
    name: 'datascience',
    component: DataSciencePage,
    meta: { locale: 'fr' }
  },
  {
    path: '/mentions-legales',
    name: 'mentions-legales',
    component: MentionsLegalesPage,
    meta: { locale: 'fr' }
  },
]

// Routes anglaises (avec préfixe /en)
const englishRoutes = [
  {
    path: '/en',
    name: 'home-en',
    component: HomeViewEn,
    meta: { locale: 'en' }
  },
  {
    path: '/en/saas',
    name: 'saas-en',
    component: SaasServicesPageEn,
    meta: { locale: 'en' }
  },
  {
    path: '/en/chatbot',
    name: 'chatbot-en',
    component: ChatbotServicePageEn,
    meta: { locale: 'en' }
  },
  {
    path: '/en/nocode',
    name: 'nocode-en',
    component: NoCodeServicePageEn,
    meta: { locale: 'en' }
  },
  {
    path: '/en/seo',
    name: 'seo-en',
    component: SeoServicePageEn,
    meta: { locale: 'en' }
  },
  {
    path: '/en/contact',
    name: 'contact-en',
    component: ContactViewEn,
    meta: { locale: 'en' }
  },
  {
    path: '/en/datascience',
    name: 'datascience-en',
    component: DataSciencePageEn,
    meta: { locale: 'en' }
  },
  {
    path: '/en/mentions-legales',
    name: 'mentions-legales-en',
    component: MentionsLegalesPageEn,
    meta: { locale: 'en' }
  },
]

// Combinaison des routes
const routes = [...frenchRoutes, ...englishRoutes]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // Cette fonction fait défiler la page vers le haut lors des changements de route
    return { top: 0 }
  }
})

export default router